<div *ngIf="data"
    (finderInViewport)="inViewport($event)"
    [requireFullElement]="requireFullElement"
    [addedOffset]="addedOffset"
    class="header"
    [ngClass]="{'hr-decoration': hrDecoration}"
>
    <div class="lottie-header" *ngIf="data.lottie">
        @defer {
            <finder-lottie
                [data]="data.lottie"
                [playback]="onPlayback"
            ></finder-lottie>
        }
    </div>
    <div class="header-wrapper" [ngClass]="{'hidden': isVisible === false, 'has-lottie': data.lottie}">
        <h2 *ngIf="model?.title && model.title !== '#'"
            [ngClass]="{'decorative-line': data.decorativeLine}"
            class="title desktop-{{model.titleAlignment}} mobile-{{model.mobileTitleAlignment}}"
        >
            <finder-picture *ngIf="data.iconImage"
                [picture]="data.iconPicture"
            ></finder-picture>
            <finder-font-icon *ngIf="data.icon"
                [hexValue]="data.icon"
            ></finder-font-icon>
            <span class="title-inner" [innerHTML]="model.title | safeHtml"></span>
        </h2>
        <finder-horizontal-rule *ngIf="hrDecoration" [data]="hrDecoration"></finder-horizontal-rule>
        <div *ngIf="model?.subtitle && model.subtitle !== '#'"
            class="subtitle desktop-{{model.subtitleAlignment}} mobile-{{model.mobileSubtitleAlignment}}"
        >
            <finder-picture *ngIf="data.iconImage && !model?.title"
                [picture]="data.iconPicture"
            ></finder-picture>
            <finder-font-icon *ngIf="data.icon && !model?.title"
                [hexValue]="data.icon"
            ></finder-font-icon>
            <span [innerHTML]="model.subtitle | safeHtml"></span>
        </div>
        <div *ngIf="data?.headerLink"
            class="link desktop-{{model.headerLinkAlignment}} mobile-{{model.mobileHeaderLinkAlignment}}"
        >

            <finder-anchor
                [href]="data.headerLink"
                [target]="data?.headerLinkTarget"
            >
                <span [innerHTML]="data.headerLinkText | safeHtml"></span>
            </finder-anchor>
        </div>
    </div>
</div>
